<section class="section m-list">
  <div class="container">
    <div class="row">
      <div class="sidebar--filters col-12 col-lg-4 offset-lg-0 col-xl-3" [ngClass]="{'is-open': openedFilters}">
        <span class="sidebar__exit d-lg-none" (click)="filtersVisibleEvent()">
          <span class="icon-x"></span>
        </span>
        <app-list-search
          [baseSearchFilters]="basicFilters"
          [advancedFilters]="advancedFilters"
          (filtersUpdate)="onFilterUpdate()"
          (pageChangeOnly)="pageChangeOnly($event)"
          (beforeFiltersUpdate)="beforeFilterUpdate()"
          [newCarsOfferCount]="newCarsOfferCount"
          [initOfferCount]="initOfferCount"
          (showResults)="filtersVisibleEvent()"
        ></app-list-search>
      </div>
      <div class="col-12 col-lg-8 col-xl-9">
        <app-list-result
          [result]="result"
          [sorting]="sort"
          [dealerCode]="dealerCode"
          (filtersVisibleEvent)="filtersVisibleEvent()"
          (pageChange)="pageChange($event)"
          (sortChange)="sortChange($event)"
          [listLoading]="resultListLoading"
          [newCarsOfferCount]="newCarsOfferCount"
          [initOfferCount]="initOfferCount"
        ></app-list-result>
      </div>
    </div>
  </div>
</section>
